import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsModule } from '@lib/icons';
import { ButtonModule, DropdownModule } from '@lib/ui';
import { AvatarModule } from '@modules/avatar';
import { TranslateModule } from '@project/translate';
import { MediaDevicePreviewComponent } from './media-device-preview.component';

@NgModule({
  declarations: [MediaDevicePreviewComponent],
  imports: [CommonModule, IconsModule, ButtonModule, DropdownModule, AvatarModule, TranslateModule],
  exports: [MediaDevicePreviewComponent],
})
export class MediaDevicePreviewModule {}
